import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "calendar" }
const _hoisted_2 = { class: "navigatorContainer" }
const _hoisted_3 = { class: "navigatorTitle" }
const _hoisted_4 = { class: "weekDaysContainer" }
const _hoisted_5 = {
  class: "calendarDaysContainer",
  ref: "daysContainer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_chevron_left = _resolveComponent("icon-chevron-left")!
  const _component_icon_chevron_right = _resolveComponent("icon-chevron-right")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "prev",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goPrev && _ctx.goPrev(...args)))
      }, [
        _createVNode(_component_icon_chevron_left)
      ]),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.navigatorTitle), 1),
      _createElementVNode("div", {
        class: "next",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goNext && _ctx.goNext(...args)))
      }, [
        _createVNode(_component_icon_chevron_right)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.originalWeekDays, (giorno, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "weekDay",
          key: i
        }, [
          _createElementVNode("b", null, _toDisplayString(giorno), 1)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "default", { days: _ctx.days })
    ], 512)
  ]))
}